import enMessages from "../locales/th_TH";

const Thai = {
  messages: {
    ...enMessages,
  },
  locale: "th-TH",
};

export default Thai;
